import { ARBITRARY_ID_APP_MODAL, DOMAIN_TYPE_ARBITRARY } from '../../../consts';
export var getAppModal = function (state) {
    return (state.domain[DOMAIN_TYPE_ARBITRARY] || {})[ARBITRARY_ID_APP_MODAL] || null;
};
